import Vue from "vue";
import axios from "axios";
import store from "../store";
Vue.prototype.$baseURL = "https://api.master-chicken.com/api/v1";

axios.defaults.baseURL = `${Vue.prototype.$baseURL}/`;

window.axios = axios;
Vue.prototype.$axios = axios;


axios.defaults.headers = {
  accept: "application/json",
  "Content-Type": "application/json",
  'Accept-Language':  'en',
  Authorization: `Bearer ${localStorage.getItem("token")}`,
};

export default async () => {
  // show loader in each request
  window.axios.interceptors.request.use(
    (confiq) => {
      if (confiq.method != "get") {
        store.dispatch("loading", true);
      }
      return confiq;
    },
    (error) => {
      return error;
    }
  );

  window.axios.interceptors.response.use(
    function (response) {
      store.dispatch("loading", false);
      return response;
    },
    async function (error) {
      if (error.response.status == 401) {
        store.dispatch("logout");
      }
      store.dispatch("loading", false);
      // response with status code > 200 is here
      return error.response.data;
    }
  );
};
